<template>
  <b-container fluid>
    <b-row>
      <b-col cols="2">
            <b-img :src="imageSrcSpider" fluid class="fixed-top" style="padding-top: 62px; width:30%;"></b-img>
            <div v-if="false"><a :href="imageSrcKnowledge" target="_blank"><b-img :src="imageSrcKnowledge" fluid ></b-img></a></div>
      </b-col>
      <b-col cols="10">
      <b-row>
        <b-col cols="12">
          <h3>{{ $t('LNG_TEST', this.lang) }} {{this.testName}} {{this.testDiscipline}}</h3>
        </b-col>
      </b-row>
      <b-row>   
        <b-col cols="8" offset="2"  class="text-left">
          <b-form-select v-model="selectStudent.value" :options="selectStudent.options" class="mb-3" v-on:change="studentSelected"/>
        </b-col>
      </b-row>
      <b-row v-if="selectStudent.value != '' && selectStudent.value != undefined">
        <b-col cols="12">
              Total des points de l'élève: {{this.totalPointsStudent}} / {{this.totalPoints}}
        </b-col>
      </b-row>
      
      <b-row v-if="selectStudent.value != '' && selectStudent.value != undefined">
        <b-col cols="8" offset="2">
          <div v-for="(exercice, indexe) in exercices">
            <b-row v-bind:class="{'selectedExercice': exerciceIsSelected[indexe]}" class="border pt-2 pb-2" v-on:click="selectExercice(indexe, $event)" style="cursor: pointer;">
             <b-col cols="10" class="text-left">{{$t('LNG_EXERCICE', this.lang)}} {{exercice.exoNumber}} <i style="cursor: pointer;" v-bind:class="{'fa-sort-down': !exerciceIsShown[indexe], 'fa-sort-up': exerciceIsShown[indexe], 'align-top': !exerciceIsShown[indexe]}" class="fa fa-2x" v-on:click.prevent="toggleExercice($event, indexe)"></i></b-col>
             <b-col cols="2" class="text-right"> {{totalByExoStudent[indexe]}} / {{totalByExo[indexe]['points']}} {{$t('LNG_PTS', this.lang)}}</b-col>
            </b-row>
            <div v-for="(part, indexePart) in exercice.parts">
              <transition name="fade">
              <b-row v-show="exerciceIsShown[indexe]">
                <b-col cols="11" offset="1" class="text-left" style="cursor: pointer;" v-bind:class="{'selectedExercice': partIsSelected[indexe * 100 + indexePart]}">
                  <b-row class="border pt-2" v-on:click.prevent="selectPart(indexe, indexePart)">
                    <b-col cols="10">{{$t('LNG_PART', this.lang)}} {{part.partName}}</b-col>
                    <b-col cols="2" class="text-right">{{totalByPartStudent[indexe][partLetterToNumber(part.partName)]}} / {{totalByExo[indexe]['parts'][part.partName]}} {{$t('LNG_PTS', this.lang)}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
              </transition>
              <div v-for="(exo, indexeExo) in part.exercices">
                <transition name="fade">
                <b-row v-show="exerciceIsShown[indexe]">
                  <b-col cols="10" offset="2" class="text-left">
                    <b-row style="cursor: pointer;" v-on:click.prevent="selectObjective(exo.exoId)" v-bind:class="{'border-objectifLight': indexeExo %2 !== 0, 'border-objectif': indexeExo %2 === 0, 'objective-selected': objectiveIsSelected[exo.exoId]}" class="pt-1">
                      <b-col cols="8">{{exo.obj}}</b-col>
                      <b-col cols="2" class="pb-1 pt-1">{{exo.pts}} pts</b-col>
                      <b-col cols="2" class="pb-1 pt-1"><b-form-input v-b-tooltip.hover.left="$t('LNG_POINTS', this.lang)" type="text" size="sm" v-model="studentPoints[exercice.exoNumber][partLetterToNumber(part.partName)][exo.pos].pts" v-on:change="savePoints(exo.exoId, studentPoints[exercice.exoNumber][partLetterToNumber(part.partName)][exo.pos].pts)"></b-form-input></b-col>
                    </b-row>
                    <b-row class="pt-1">
                      <b-col class="pb-3"><b-form-textarea v-model="studentPoints[exercice.exoNumber][partLetterToNumber(part.partName)][exo.pos].comments" v-on:change="saveComments(exo.exoId, studentPoints[exercice.exoNumber][partLetterToNumber(part.partName)][exo.pos].comments)" type="text" rows="2" max-rows="6"/></b-col>
                    </b-row>
                  </b-col>
                </b-row>
                </transition>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'mainview',
  components: {
  },
  data () {
    return {
      checked: true,
      testName: '',
      testComment: '',
      testDiscipline: '',
      selectStudent: {
        options: [],
        value: null
      },
      exercices: [],
      graphSource: '',
      imageSrcSpider: '',
      imageSrcKnowledge: '',
      selectedExercice: -1, // Utilisé pour stocker l'id de l'objectif sélectionné
      selectedPart: -1, // Utilisé pour stocker l'id de l'objectif sélectionné
      selectedObjective: -1, // Utilisé pour stocker l'id de l'objectif sélectionné
      exerciceIsSelected: [], // Utilisé pour montrer ou cacher les exercices
      partIsSelected: [], // Utilisé pour savoir quelle partie est sélectionnée
      objectiveIsSelected: [], // Utilisé pour savoir quel objectif est sélectionné
      exerciceIsShown: [], // Utilisé pour savoir si l'exercice est condensé
      loading: false, // Indique si l'application est en train de loader
      studentPoints: [], // Utilisé pour stocker les points de l'élève
      totalByExoStudent: [],
      totalByPartStudent: [],
      totalPointsStudent: 0
    }
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.loadData()
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ]),
    totalByExo: function () {
      var totalExo = []
      var temp = 0
      var cpt = 0
      this.exercices.forEach(function (element) {
        totalExo[cpt] = []
        totalExo[cpt]['parts'] = []
        if (element['parts'] !== undefined) {
          Object.keys(element['parts']).forEach(function (key2) {
            totalExo[cpt]['parts'][key2] = 0
            Object.keys(element['parts'][key2]['exercices']).forEach(function (key3) {
              if (element['parts'][key2]['exercices'][key3]['pts'] !== '' && element['parts'][key2]['exercices'][key3]['pts'] != null) {
                temp = temp + parseFloat(element['parts'][key2]['exercices'][key3]['pts'])
                totalExo[cpt]['parts'][key2] = totalExo[cpt]['parts'][key2] + parseFloat(element['parts'][key2]['exercices'][key3]['pts'])
              }
            }, this)
          }, this)
        }
        totalExo[cpt]['points'] = temp
        cpt = cpt + 1
        temp = 0
      }, this)
      return totalExo
    }
  },
  methods: {
    loadData: function () {
      this.loading = true
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestDataResults',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.testName = response.data.name
        this.testDiscipline = response.data.discipline

        while (this.selectStudent.options.length > 0) {
          this.selectStudent.options.pop()
        }
        this.selectStudent.options.push({text: this.$t('LNG_PLEASE_SELECT_A_STUDENT', this.lang), value: null})
        response.data.students.forEach((e) => {
          this.selectStudent.options.push({text: e.name + ' (' + e.points + ' pts' + ' ' + e.grade + ')', value: e.id})
        })

        this.exercices = []
        this.exercices = Object.keys(response.data.exercices).map(function (k) { return response.data.exercices[k] })

        // console.log(response.data.exercices)
        // this.exercices = response.data.exercices
        var cpt = 0
        this.studentPoints = []
        Object.keys(this.exercices).forEach(function (key) {
          this.exerciceIsShown[cpt] = true
          this.exerciceIsSelected[cpt] = false
          this.studentPoints[cpt + 1] = []
          this.totalByPartStudent[cpt] = []
          cpt = cpt + 1
        }, this)

        this.exercices.forEach((e) => {
          var p = Object.keys(e.parts).map(function (k) { return e.parts[k] })
          p.forEach((pp) => {
            this.studentPoints[e.exoNumber][this.partLetterToNumber(pp.partName)] = []
            pp.exercices.forEach((exo) => {
              this.studentPoints[e.exoNumber][this.partLetterToNumber(pp.partName)][exo.pos] = {id: exo.exoId, pts: '', comments: ''}
            })
          })
        })
        this.totalPoints = response.data.totalPts
        this.loading = false
      })
    },
    partLetterToNumber: function (letter) {
      switch (letter) {
        case 'a' : return 1
        case 'b' : return 2
        case 'c' : return 3
        case 'd' : return 4
        case 'e' : return 5
        case 'f' : return 6
        case 'g' : return 7
        case 'h' : return 8
        case 'i' : return 9
        case 'j' : return 10
        case 'k' : return 11
        case 'l' : return 12
        case 'm' : return 13
        case 'n' : return 14
        case 'o' : return 15
        case 'p' : return 16
        case 'q' : return 17
      }
      return 0
    },
    selectExercice (position, event) { // Utilisé pour sélectionner un exercice
      if (this.selectedPart !== -1) {
        this.partIsSelected[this.selectedPart] = false
        this.selectedPart = -1
      }
      if (this.selectedObjective !== -1) {
        this.objectiveIsSelected[this.selectedObjective] = false
        this.selectedObjective = -1
      }
      if (this.selectedExercice === position) {
        this.exerciceIsSelected[this.selectedExercice] = false
        this.selectedExercice = -1
      } else {
        this.exerciceIsSelected[this.selectedExercice] = false
        this.selectedExercice = position
        this.exerciceIsSelected[this.selectedExercice] = true
      }
      event.stopPropagation()
      this.$forceUpdate()
    },
    selectPart (indexExo, indexPart) { // Utilisé pour sélectionner une partie
      if (this.selectedExercice !== -1) {
        this.exerciceIsSelected[this.selectedExercice] = false
        this.selectedExercice = -1
      }
      if (this.selectedObjective !== -1) {
        this.objectiveIsSelected[this.selectedObjective] = false
        this.selectedObjective = -1
      }
      if (this.selectedPart === (100 * indexExo + indexPart)) {
        this.partIsSelected[100 * indexExo + indexPart] = false
        this.selectedPart = -1
      } else {
        this.partIsSelected[this.selectedPart] = false
        this.selectedPart = 100 * indexExo + indexPart
        this.partIsSelected[this.selectedPart] = true
      }
      this.$forceUpdate()
    },
    selectObjective: function (exoId) {
      if (this.selectedPart !== -1) {
        this.partIsSelected[this.selectedPart] = false
        this.selectedPart = -1
      }
      if (this.selectedExercice !== -1) {
        this.exerciceIsSelected[this.selectedExercice] = false
        this.selectedExercice = -1
      }
      if (this.selectedObjective === exoId) {
        this.objectiveIsSelected[exoId] = false
        this.selectedObjective = -1
      } else {
        this.objectiveIsSelected[this.selectedObjective] = false
        this.selectedObjective = exoId
        this.objectiveIsSelected[exoId] = true
      }
      this.$forceUpdate()
    },
    toggleExercice (event, exerciceNumber) { // Utiliser pour afficher ou cacher un exercice
      event.stopPropagation() // Nécessaire pour ne pas faire une sélection de la ligne après le clic pour fermer l'exercice
      this.exerciceIsShown[exerciceNumber] = !this.exerciceIsShown[exerciceNumber]
      this.$forceUpdate()
    },
    studentSelected: function (newSelection) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestPtStudent',
          testId: this.$route.params.testId,
          studentId: newSelection
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        // Empty all student points
        this.loading = true
        var cpt = 0
        var cptPart = 1
        this.studentPoints.forEach((parts) => {
          this.totalByExoStudent[cpt] = 0
          this.totalByPartStudent[cpt] = []
          cptPart = 1
          parts.forEach((exos) => {
            this.totalByPartStudent[cpt][cptPart] = 0
            exos.forEach((e) => {
              e.pts = ''
              e.comments = ''
            })
            cptPart = cptPart + 1
          })
          cpt = cpt + 1
        })
        if (response.data.points.length > 0) {
          response.data.points.forEach((re) => {
            this.studentPoints[re.exoNum][this.partLetterToNumber(re.part)][re.pos].pts = re.points
            this.studentPoints[re.exoNum][this.partLetterToNumber(re.part)][re.pos].comments = re.comments
            this.totalByExoStudent[re.exoNum - 1] = Number(this.totalByExoStudent[re.exoNum - 1]) + Number(re.points)
            this.totalByPartStudent[re.exoNum - 1][this.partLetterToNumber(re.part)] = this.totalByPartStudent[re.exoNum - 1][this.partLetterToNumber(re.part)] + Number(re.points)
          })
        }
        this.loading = false
        // Charger le graphique des savoirs
        this.imageSrcSpider = response.data.imagePathSpider
        // Charger le graphique des résultats
        this.imageSrcKnowledge = response.data.imageSrcKnowledge

        this.totalPointsStudent = this.calculateTotalStudent()
      })
    },
    back: function () { // Traitée
      this.$router.push({ path: '/testEdit/' + this.$route.params.testId })
    },
    savePoints: function (exoId, exoPts) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'savePointsToStudent',
          testId: this.$route.params.testId,
          studentId: this.selectStudent.value,
          exercice: exoId,
          points: exoPts
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.imageSrcSpider = response.data.imagePathSpider
        this.imageSrcKnowledge = response.data.imageSrcKnowledge

        // Mettre à jour le tableau des exercice
        this.totalByExoStudent[response.data.number - 1] = response.data.exoPoints

        this.totalByPartStudent[response.data.number - 1][this.partLetterToNumber(response.data.part)] = response.data.partPoint

        this.totalPointsStudent = this.calculateTotalStudent()
      })
    },
    saveComments: function (exoId, exoComments) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'saveCommentsToStudent',
          testId: this.$route.params.testId,
          studentId: this.selectStudent.value,
          exercice: exoId,
          comments: exoComments
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
      })
    },
    getStudentGraph: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getStudentRadarGraph',
          testId: this.$route.params.testId,
          studentId: this.selectStudent.value
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => { this.graphSource = response.data.image })
    },
    calculateTotalStudent: function () {
      var total = 0
      this.studentPoints.forEach((parts) => {
        parts.forEach((exos) => {
          exos.forEach((e) => {
            if (e !== null & e.pts !== null) {
              total = total + Number(e.pts)
            }
          })
        })
      })
      return total
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>




// WEBPACK FOOTER //
// results.vue?e3a22558